'use client';

import { hasConsentChoice } from '@lib/analytics/consent';
import { IS_CONSENT_REQUIRED } from '@lib/analytics/constants';
import CookieSettingsModal, {
  useCookieSettingsModal,
} from '@modules/analytics/components/cookie-settings-modal';
import { usePathname } from 'next/navigation';
import { useCallback, useEffect, useState } from 'react';

const CONSENT_SUPPRESSED_PATHS = ['/privacy', '/cookie-policy'];

const CookieConsent = () => {
  const pathname = usePathname();
  const modal = useCookieSettingsModal();
  const [requiresChoice, setRequiresChoice] = useState(false);

  const isSuppressed = CONSENT_SUPPRESSED_PATHS.some((p) =>
    pathname.startsWith(p),
  );

  useEffect(() => {
    if (!isSuppressed && IS_CONSENT_REQUIRED && !hasConsentChoice()) {
      setRequiresChoice(true);
      modal.open();
    }
  }, [isSuppressed, modal.open]);

  const handleClose = useCallback(() => {
    if (requiresChoice && hasConsentChoice()) {
      setRequiresChoice(false);
    }
    modal.close();
  }, [requiresChoice, modal.close]);

  return (
    <CookieSettingsModal
      isOpen={modal.isOpen}
      onClose={handleClose}
      isDismissible={!requiresChoice}
    />
  );
};

export default CookieConsent;
